import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {VirtualKeyboardComponent} from '../../components/virtual-keyboard/virtual-keyboard.component';
import {AppConstants} from '../../shared/app-constants';

@Component({
  selector: 'app-payment-aborted',
  imports: [CommonModule, VirtualKeyboardComponent],
  templateUrl: './payment-aborted.component.html',
  styleUrl: './payment-aborted.component.scss',
  standalone:true
})
export class PaymentAbortedComponent {
  selectedPaymentMethod: 'payNow' | 'bank' | null  = null;
  paymentCollected = false;

  constructor(private readonly router: Router) { }

  onSelectMethod(paymentMethod: 'payNow' | 'bank' | null) {
    this.selectedPaymentMethod = this.selectedPaymentMethod === paymentMethod ? null : paymentMethod;
  }

  onClick() {
    this.router.navigate([''])
  }

  handleDropdownKey(event: any) {
    return AppConstants.handleDropdownKey(event);
  }
}
